import { Col, Space, notification, Row, Tooltip, InputNumber, Progress, Skeleton, Spin, Alert } from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import {
  EditOutlined,
  RocketOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined,
  CloseCircleOutlined,
  WarningOutlined,
  SyncOutlined,
  ExclamationCircleOutlined,
  LinkOutlined,
  CopyOutlined,
  DownloadOutlined,
  CheckOutlined,
  DollarOutlined,
  SaveOutlined,
  ReloadOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import config from "../../config";
import { formatDateTime, getUserToken } from "../../utils/helpers";
import MobHeader from "../../Components/Header/MobHeader";
import {
  ThemeButton,
  ThemeFilterBtn,
  ThemeMainWrapper,
  ThemeModal,
  ThemeInput,
  ThemeRadio,
} from "../Styles/Theme";
import {
  getCampaignByIdApi,
  getCampaignByIdReset,
  publishToPureSpectrumApi,
  publishToPureSpectrumReset,
  launchCampaignApi,
  launchCampaignReset,
  pauseCampaignApi,
  pauseCampaignReset,
  resumeCampaignApi,
  resumeCampaignReset,
  closeCampaignApi,
  closeCampaignReset,
  forceCloseCampaignApi,
  forceCloseCampaignReset,
  syncCampaignApi,
  syncCampaignReset,
  getTranscriptStatsApi,
  getTranscriptStatsReset,
  updateCPIApi,
  updateCPIReset,
  getElevenLabsCreditsApi,
  getElevenLabsCreditsReset,
  getPureSpectrumStatsApi,
  getPureSpectrumStatsReset,
} from "../../store/actions/campaignAction";
import {
  createProjectFromCampaignApi,
  createProjectFromCampaignReset,
} from "../../store/actions/projectAction";
import {
  saveCampaignTemplateApi,
  saveCampaignTemplateReset,
} from "../../store/actions/campaignTemplateAction";
import CampaignCallsSection from "./CampaignCallsSection";
import EmailInviteSection from "./EmailInviteSection";
import { useCampaignPermissions, useProjectPermissions } from "../../utils/permissions";
import {
  HeaderSection,
  HeaderLeft,
  HeaderRight,
  CampaignTitleWrapper,
  CampaignTitle,
  CampaignSubtitle,
  SectionDivider,
  SurveyMessageContent,
  ContentWrapper,
  PureSpectrumCard,
  HeaderInfoCard,
  TargetAudienceCard,
  SyncStatusTag,
  QuotaFieldCard,
  QuotaRow,
  HealthCheckHeader,
  HealthCheckRow,
  PsStatsTabs,
} from "./CampaignDetailStyle";
import { StatusBadgeWrapper } from "./CampaignsStyle";
import { ProjectSettingsCard } from "../Projects/ProjectsStyle";
import { getStudyDetailStatusConfig, getStudyDetailStatusIcon } from "../../Components/StatusTag";

const CampaignDetail = (props) => {
  const {
    getCampaignById,
    getCampaignByIdReset,
    getCampaignByIdState,
    publishToPureSpectrum,
    publishToPureSpectrumReset,
    publishToPureSpectrumState,
    launchCampaign,
    launchCampaignReset,
    launchCampaignState,
    pauseCampaign,
    pauseCampaignReset,
    pauseCampaignState,
    resumeCampaign,
    resumeCampaignReset,
    resumeCampaignState,
    closeCampaign,
    closeCampaignReset,
    closeCampaignState,
    forceCloseCampaign,
    forceCloseCampaignReset,
    forceCloseCampaignState,
    syncCampaign,
    syncCampaignReset,
    syncCampaignState,
    getTranscriptStats,
    getTranscriptStatsReset,
    getTranscriptStatsState,
    createProjectFromCampaign,
    createProjectFromCampaignReset,
    createProjectFromCampaignState,
    updateCPI,
    updateCPIReset,
    updateCPIState,
    getElevenLabsCredits,
    getElevenLabsCreditsReset,
    getElevenLabsCreditsState,
    saveCampaignTemplate,
    saveCampaignTemplateReset,
    saveCampaignTemplateState,
    getPureSpectrumStats,
    getPureSpectrumStatsReset,
    getPureSpectrumStatsState,
  } = props;

  const navigate = useNavigate();
  const { id } = useParams();
  const [urlSearchParams] = useSearchParams();
  const fromFolderId = urlSearchParams.get('fromFolderId');
  const fromFolderName = urlSearchParams.get('fromFolderName');

  const getBackUrl = () => {
    if (fromFolderId) {
      return `/campaigns/?folderId=${fromFolderId}&folderName=${encodeURIComponent(fromFolderName || '')}`;
    }
    return '/campaigns/';
  };

  const [confirmModal, setConfirmModal] = useState({ visible: false, type: null });
  const [feotModal, setFeotModal] = useState({ visible: false, operation: null }); // operation: 'publish' | 'sync'
  const [feotLoading, setFeotLoading] = useState(false);
  const [createProjectAfterClose, setCreateProjectAfterClose] = useState(false);
  const [createProjectDemographicFormat, setCreateProjectDemographicFormat] = useState(null);
  const [transcriptStats, setTranscriptStats] = useState({
    good: 0,
    neutral: 0,
    bad: 0,
    total: 0,
  });
  const [isFetchingFreshStats, setIsFetchingFreshStats] = useState(false);
  const [isEditingCPI, setIsEditingCPI] = useState(false);
  const [cpiValue, setCpiValue] = useState(null);
  const [saveTemplateModalVisible, setSaveTemplateModalVisible] = useState(false);
  const [templateName, setTemplateName] = useState('');
  const [psStats, setPsStats] = useState(null);

  // Permission check - shortcut hook
  const { can, isSuperAdmin } = useCampaignPermissions();
  const { can: canProject } = useProjectPermissions();

  // Fetch campaign data
  useEffect(() => {
    if (id) {
      getCampaignById(id);
    }
  }, [id, getCampaignById]);

  // Fetch Eleven Labs credits on page load (if user has permission)
  useEffect(() => {
    if (isSuperAdmin || can('view-elevenlabs-credits')) {
      getElevenLabsCredits();
    }
    return () => {
      getElevenLabsCreditsReset();
    };
  }, [isSuperAdmin, can, getElevenLabsCredits, getElevenLabsCreditsReset]);

  // Handle campaign data response
  useEffect(() => {
    if (getCampaignByIdState.apiState === 'error') {
      // For 403 errors, the axios interceptor already shows a notification
      // Only show notification for other errors (404, 500, etc.)
      const statusCode = getCampaignByIdState.statusCode || getCampaignByIdState.error?.response?.status;
      if (statusCode !== 403) {
        notification.error({
          message: 'Error',
          description: getCampaignByIdState.message || 'Failed to fetch campaign',
        });
      }
      getCampaignByIdReset();
      navigate(getBackUrl());
    } else if (getCampaignByIdState.apiState === 'success') {
      // Fetch transcript stats when campaign is loaded (for both PureSpectrum and Email-invite)
      const campaignData = getCampaignByIdState.data?.data || getCampaignByIdState.data;
      if (campaignData) {
        getTranscriptStats(id);
      }
    }
  }, [getCampaignByIdState, getCampaignByIdReset, navigate, id, getTranscriptStats]);

  // Handle transcript stats response
  useEffect(() => {
    if (getTranscriptStatsState.apiState === 'success') {
      const statsData = getTranscriptStatsState.data?.data || getTranscriptStatsState.data;
      const good = statsData?.good_transcripts || 0;
      const neutral = statsData?.neutral_transcripts || 0;
      const bad = statsData?.bad_transcripts || 0;
      setTranscriptStats({
        good,
        neutral,
        bad,
        total: good + neutral + bad,
      });
      setIsFetchingFreshStats(false);
      getTranscriptStatsReset();
    } else if (getTranscriptStatsState.apiState === 'error') {
      setIsFetchingFreshStats(false);
      getTranscriptStatsReset();
    }
  }, [getTranscriptStatsState, getTranscriptStatsReset]);

  // Fetch PureSpectrum stats when campaign loads (if eligible)
  useEffect(() => {
    if (getCampaignByIdState.apiState === 'success') {
      const campaignData = getCampaignByIdState.data?.data || getCampaignByIdState.data;
      if (
        campaignData?.ps_survey_id &&
        ['in_progress', 'paused', 'completed'].includes(campaignData?.status)
      ) {
        getPureSpectrumStats(id);
      }
    }
  }, [getCampaignByIdState.apiState]);

  // Handle PureSpectrum stats response
  useEffect(() => {
    if (getPureSpectrumStatsState.apiState === 'success') {
      const data = getPureSpectrumStatsState.data?.data || getPureSpectrumStatsState.data;
      setPsStats(data);
      getPureSpectrumStatsReset();
    } else if (getPureSpectrumStatsState.apiState === 'error') {
      getPureSpectrumStatsReset();
    }
  }, [getPureSpectrumStatsState.apiState]);

  // Handle Publish to PureSpectrum response
  useEffect(() => {
    if (publishToPureSpectrumState.apiState === 'success') {
      notification.success({
        message: 'Success',
        description: publishToPureSpectrumState.message || 'Study published! It is now in review and will go live soon.',
      });
      publishToPureSpectrumReset();
      getCampaignById(id);
    } else if (publishToPureSpectrumState.apiState === 'error') {
      const psError = publishToPureSpectrumState.errors?.ps_error;
      if (psError?.ps_api_response_code === 1018) {
        setFeotModal({ visible: true, operation: 'publish' });
      } else {
        notification.error({
          message: 'Error',
          description: publishToPureSpectrumState.message || 'Failed to publish study',
        });
      }
      publishToPureSpectrumReset();
    }
  }, [publishToPureSpectrumState, publishToPureSpectrumReset, getCampaignById, id]);

  // Handle Launch Campaign response
  useEffect(() => {
    if (launchCampaignState.apiState === 'success') {
      notification.success({
        message: 'Success',
        description: launchCampaignState.message || 'Study launched successfully',
      });
      launchCampaignReset();
      getCampaignById(id);
      setConfirmModal({ visible: false, type: null });
    } else if (launchCampaignState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description: launchCampaignState.message || 'Failed to launch campaign',
      });
      launchCampaignReset();
      setConfirmModal({ visible: false, type: null });
    }
  }, [launchCampaignState, launchCampaignReset, getCampaignById, id]);

  // Handle Pause Campaign response
  useEffect(() => {
    if (pauseCampaignState.apiState === 'success') {
      notification.success({
        message: 'Success',
        description: pauseCampaignState.message || 'Study paused successfully',
      });
      pauseCampaignReset();
      getCampaignById(id);
    } else if (pauseCampaignState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description: pauseCampaignState.message || 'Failed to pause campaign',
      });
      pauseCampaignReset();
    }
  }, [pauseCampaignState, pauseCampaignReset, getCampaignById, id]);

  // Handle Resume Campaign response
  useEffect(() => {
    if (resumeCampaignState.apiState === 'success') {
      notification.success({
        message: 'Success',
        description: resumeCampaignState.message || 'Study resumed successfully',
      });
      resumeCampaignReset();
      getCampaignById(id);
    } else if (resumeCampaignState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description: resumeCampaignState.message || 'Failed to resume campaign',
      });
      resumeCampaignReset();
    }
  }, [resumeCampaignState, resumeCampaignReset, getCampaignById, id]);

  // Handle Close Campaign response
  useEffect(() => {
    if (closeCampaignState.apiState === 'success') {
      notification.success({
        message: 'Success',
        description: closeCampaignState.message || 'Study closed successfully',
      });
      closeCampaignReset();

      // Auto-create project if user chose "Close & Create Project"
      if (createProjectAfterClose) {
        const campaignData = getCampaignByIdState.data?.data || getCampaignByIdState.data;
        if (campaignData) {
          const projectName = `${campaignData.campaign_name} Project`;
          createProjectFromCampaign({ campaignId: id, name: projectName, ...(createProjectDemographicFormat && { demographic_format: createProjectDemographicFormat }) });
          // Keep modal open - will be closed when project creation completes
        } else {
          setCreateProjectAfterClose(false);
          setConfirmModal({ visible: false, type: null });
          getCampaignById(id);
        }
      } else {
        setConfirmModal({ visible: false, type: null });
        getCampaignById(id);
      }
    } else if (closeCampaignState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description: closeCampaignState.message || 'Failed to close campaign',
      });
      closeCampaignReset();
      setConfirmModal({ visible: false, type: null });
      setCreateProjectAfterClose(false);
      setCreateProjectDemographicFormat(null);
    }
  }, [closeCampaignState, closeCampaignReset, getCampaignById, id, createProjectAfterClose, getCampaignByIdState, createProjectFromCampaign]);

  // Handle Force Close Campaign response
  useEffect(() => {
    if (forceCloseCampaignState.apiState === 'success') {
      notification.success({
        message: 'Success',
        description: forceCloseCampaignState.message || 'Study force closed successfully',
      });
      forceCloseCampaignReset();
      setConfirmModal({ visible: false, type: null });
      getCampaignById(id);
    } else if (forceCloseCampaignState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description: forceCloseCampaignState.message || 'Failed to force close study',
      });
      forceCloseCampaignReset();
      setConfirmModal({ visible: false, type: null });
    }
  }, [forceCloseCampaignState, forceCloseCampaignReset, getCampaignById, id]);

  // Handle Create Project from Campaign response
  useEffect(() => {
    if (createProjectFromCampaignState.apiState === 'success') {
      notification.success({
        message: 'Success',
        description: 'Project created successfully',
      });
      setCreateProjectAfterClose(false);
      setConfirmModal({ visible: false, type: null });
      setCreateProjectDemographicFormat(null);
      createProjectFromCampaignReset();

      // Navigate to the new project detail page
      const projectData = createProjectFromCampaignState.data?.data || createProjectFromCampaignState.data;
      if (projectData?.project?._id) {
        navigate(`/projects/details/${projectData.project._id}`);
      } else {
        navigate('/projects');
      }
    } else if (createProjectFromCampaignState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description: createProjectFromCampaignState.message || 'Failed to create project',
      });
      setCreateProjectAfterClose(false);
      setConfirmModal({ visible: false, type: null });
      setCreateProjectDemographicFormat(null);
      createProjectFromCampaignReset();
      getCampaignById(id);
    }
  }, [createProjectFromCampaignState, createProjectFromCampaignReset, navigate, getCampaignById, id]);

  // Handle Sync Campaign response
  useEffect(() => {
    if (syncCampaignState.apiState === 'success') {
      notification.success({
        message: 'Success',
        description: syncCampaignState.message || 'Study synced successfully',
      });
      syncCampaignReset();
      getCampaignById(id);
    } else if (syncCampaignState.apiState === 'error') {
      const psError = syncCampaignState.errors?.ps_error;
      if (psError?.ps_api_response_code === 1018) {
        setFeotModal({ visible: true, operation: 'sync' });
      } else {
        notification.error({
          message: 'Error',
          description: syncCampaignState.message || 'Failed to sync campaign',
        });
      }
      syncCampaignReset();
    }
  }, [syncCampaignState, syncCampaignReset, getCampaignById, id]);

  // Handle Update CPI response
  useEffect(() => {
    if (updateCPIState.apiState === 'success') {
      notification.success({
        message: 'Success',
        description: updateCPIState.message || 'CPI updated successfully',
      });
      updateCPIReset();
      setIsEditingCPI(false);
      getCampaignById(id);
    } else if (updateCPIState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description: updateCPIState.message || 'Failed to update CPI',
      });
      updateCPIReset();
    }
  }, [updateCPIState, updateCPIReset, getCampaignById, id]);

  // Parse campaign data
  const responseData = getCampaignByIdState.data;
  const campaign = responseData?.data || responseData || null;
  const isFetchingCampaign = getCampaignByIdState.apiState === 'loading';

  // Helper function to get PureSpectrum sync status tag
  const getSyncStatusTag = (syncStatus) => {
    const tagConfig = {
      'not_synced': { color: 'default', text: 'Not Synced' },
      'syncing': { color: 'processing', text: 'Syncing' },
      'synced': { color: 'success', text: 'Synced' },
      'error': { color: 'error', text: 'Sync Error' },
    };
    const tagConfigValue = tagConfig[syncStatus] || tagConfig['not_synced'];
    return <SyncStatusTag color={tagConfigValue.color} icon={<SyncOutlined />}>{tagConfigValue.text}</SyncStatusTag>;
  };

  // Helper function to check if operation is allowed based on campaign and PureSpectrum/Email-invite status
  const isPureSpectrum = campaign?.study_type === 'purespectrum';
  const isEmailInvite = campaign?.study_type === 'email-invite';

  const canPublish = () => campaign && isPureSpectrum && !campaign.ps_survey_id && (campaign.status === 'saved' || campaign.status === 'ready');
  const canLaunch = () => {
    if (!campaign) return false;
    if (isPureSpectrum) {
      return campaign.ps_survey_id && campaign.status === 'published';
    }
    if (isEmailInvite) {
      // Launch only from 'saved' status - use Resume for paused
      return campaign.status === 'saved';
    }
    return false;
  };
  const canPause = () => {
    if (!campaign) return false;
    if (isPureSpectrum) {
      return campaign.ps_survey_id && campaign.status === 'in_progress';
    }
    if (isEmailInvite) {
      return campaign.status === 'in_progress';
    }
    return false;
  };
  const canResume = () => {
    if (!campaign) return false;
    if (isPureSpectrum) {
      return campaign.ps_survey_id && campaign.status === 'paused';
    }
    if (isEmailInvite) {
      return campaign.status === 'paused';
    }
    return false;
  };
  const canClose = () => {
    if (!campaign) return false;
    if (isPureSpectrum) {
      return campaign.ps_survey_id && (campaign.status === 'in_progress' || campaign.status === 'paused');
    }
    if (isEmailInvite) {
      return campaign.status === 'in_progress' || campaign.status === 'paused';
    }
    return false;
  };
  const canForceClose = () => {
    if (!campaign) return false;
    return campaign.status !== 'completed' && campaign.status !== 'saved';
  };
  const canSync = () => campaign && isPureSpectrum && campaign.ps_survey_id && campaign.status !== 'completed';

  // Handler functions
  const handleEdit = () => {
    let editUrl = `/campaigns/create-campaign/${id}`;
    if (fromFolderId) {
      editUrl += `?folderId=${fromFolderId}&folderName=${encodeURIComponent(fromFolderName || '')}`;
    }
    navigate(editUrl);
  };

  const handlePublishToPureSpectrum = () => {
    if (!canPublish()) return;
    publishToPureSpectrum(id);
  };

  const handleLaunchCampaign = () => {
    if (!canLaunch()) return;
    setConfirmModal({ visible: true, type: 'launch' });
  };

  const handlePauseCampaign = () => {
    if (!canPause()) return;
    pauseCampaign(id);
  };

  const handleResumeCampaign = () => {
    if (!canResume()) return;
    resumeCampaign(id);
  };

  const handleCloseCampaign = () => {
    if (!canClose()) return;
    // Fetch fresh transcript stats before showing modal
    setIsFetchingFreshStats(true);
    getTranscriptStats(id);
    setConfirmModal({ visible: true, type: 'close' });
  };

  const handleReviewTranscripts = () => {
    // Close the modal and scroll to the transcripts section
    setConfirmModal({ visible: false, type: null });
    // Scroll to the Call Transcripts section
    const transcriptsSection = document.querySelector('.tableCard');
    if (transcriptsSection) {
      transcriptsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleSyncCampaign = () => {
    if (!canSync()) return;
    syncCampaign(id);
  };

  const handleStartEditCPI = () => {
    setCpiValue(campaign?.cpi || null);
    setIsEditingCPI(true);
  };

  const handleCancelEditCPI = () => {
    setIsEditingCPI(false);
    setCpiValue(null);
  };

  const handleSaveCPI = () => {
    if (cpiValue === null || cpiValue === undefined || cpiValue < 0) {
      notification.error({
        message: 'Error',
        description: 'Please enter a valid CPI value',
      });
      return;
    }
    updateCPI(id, cpiValue);
  };

  const canEditCPI = () => {
    if (!campaign) return false;
    if (campaign.study_type !== 'purespectrum') return false;
    if (!campaign.ps_survey_id) return false;
    if (campaign.status === 'completed' || campaign.status === 'closed') return false;
    return can('edit');
  };

  const handleConfirmAction = () => {
    if (confirmModal.type === 'launch') {
      launchCampaign(id);
    } else if (confirmModal.type === 'close') {
      closeCampaign(id);
    } else if (confirmModal.type === 'force-close') {
      forceCloseCampaign(id);
    }
  };

  const handleCloseOnly = () => {
    setCreateProjectAfterClose(false);
    closeCampaign(id);
  };

  const handleCloseAndCreateProject = () => {
    if ((isSuperAdmin || canProject('anonymous-demographic-switch')) && !createProjectDemographicFormat) {
      notification.warning({
        message: 'Demographic Format Required',
        description: 'Please select a demographic display format before creating the library',
      });
      return;
    }
    setCreateProjectAfterClose(true);
    closeCampaign(id);
  };

  const handleCancelConfirm = () => {
    setConfirmModal({ visible: false, type: null });
    setCreateProjectAfterClose(false);
    setCreateProjectDemographicFormat(null);
  };

  const handleFeotTurnOff = async () => {
    setFeotLoading(true);
    try {
      await axios.post(`${config.api.base_url}/campaigns/${id}`, { field_evenly: false, feot_is_custom: false, feot_pacing: null, feot_interval: null }, {
        headers: { Authorization: 'Bearer ' + getUserToken() },
      });
      const op = feotModal.operation;
      setFeotModal({ visible: false, operation: null });
      setFeotLoading(false);
      if (op === 'publish') {
        publishToPureSpectrum(id);
      } else if (op === 'sync') {
        syncCampaign(id);
      }
    } catch (err) {
      setFeotLoading(false);
      notification.error({ message: 'Error', description: 'Failed to update study settings' });
    }
  };

  // Helper to format date
  const formatDate = (date) => {
    return formatDateTime(date);
  };

  // Helper to get agent name
  const getAgentName = () => {
    return campaign?.polling_agent?.agent_name || 
           campaign?.polling_agent?.name || 
           campaign?.polling_agent_id?.agent_name || 
           campaign?.polling_agent_id?.name || 
           '-';
  };

  const toSentenceCase = (value) => {
    if (value === null || value === undefined) return '';
    const stringValue = value.toString();

    // Keep country codes in uppercase (US, UK, etc.)
    if (stringValue.length === 2 && stringValue === stringValue.toUpperCase()) {
      return stringValue;
    }

    return stringValue
      .replace(/_/g, ' ')
      .replace(/-/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const formatSentenceValue = (value) => {
    if (!value) return '-';
    if (Array.isArray(value)) {
      return value.length > 0 ? value.map((item) => toSentenceCase(item)).join(', ') : '-';
    }
    return toSentenceCase(value);
  };

  // Qualification code to group label mapping (PS codes are fixed)
  const QUAL_CODE_TO_LABEL = {
    211: 'Gender', 212: 'Age', 213: 'Income', 215: 'Employment',
    216: 'Education', 217: 'Relationship', 218: 'Children', 219: 'Device',
    223: 'Region', 224: 'Division', 225: 'State', 226: 'CSA',
    227: 'MSA / CBSA', 228: 'County', 229: 'Zipcode', 231: 'DMA',
    232: 'Children', 244: 'Race / Ethnicity', 245: 'Hispanic Origin',
  };

  // Build quota performance groups from PS survey data (works for all studies)
  const buildQuotaPerformanceFromPS = () => {
    const surveyQuotas = psStats?.survey?.quotas;
    const performance = psStats?.quota_performance;
    if (!Array.isArray(surveyQuotas) || surveyQuotas.length === 0) return null;
    if (!Array.isArray(performance) || performance.length === 0) return null;

    const labelMap = psStats?.condition_label_map || {};

    // Build performance lookup by ps_quota_id
    const perfMap = {};
    for (const p of performance) {
      perfMap[p.ps_quota_id] = p;
    }

    const groups = {};
    for (const q of surveyQuotas) {
      const criteria = q.criteria || [];
      if (criteria.length === 0) continue;

      // Group label from qualification_code(s)
      const fieldLabels = criteria.map(c =>
        QUAL_CODE_TO_LABEL[c.qualification_code] || `Qualification ${c.qualification_code}`
      );
      const isInterlocked = criteria.length > 1 || q.group_key;
      const fieldLabel = isInterlocked
        ? 'Interlocked: ' + [...new Set(fieldLabels)].join(' x ')
        : fieldLabels[0];

      // Entry label: quota_title first, then resolve from condition_label_map, then range_sets
      let entryLabel = q.quota_title || '';
      if (!entryLabel) {
        const parts = criteria.map(c => {
          const qualLabels = labelMap[c.qualification_code] || {};
          if (c.condition_codes && c.condition_codes.length > 0) {
            return c.condition_codes.map(cc => qualLabels[String(cc)] || `Code ${cc}`).join(', ');
          }
          if (c.range_sets && c.range_sets.length > 0) {
            return c.range_sets.map(r => `${r.from} - ${r.to}`).join(', ');
          }
          return q.buyer_quota_id;
        });
        entryLabel = parts.join(' x ');
      }

      // Match with performance data
      const perf = perfMap[q.ps_quota_id];
      const goal = perf?.completes_goal || q.required_count || 0;
      const fielded = perf?.completes_fielded || 0;

      if (!groups[fieldLabel]) groups[fieldLabel] = [];
      groups[fieldLabel].push({
        buyerQuotaId: q.buyer_quota_id,
        label: entryLabel,
        goal,
        fielded,
        currentlyOpen: Math.max(goal - fielded, 0),
        percentage: goal > 0 ? Math.min(Math.round((fielded / goal) * 100), 100) : 0,
        isComplete: fielded >= goal,
      });
    }

    return Object.keys(groups).length > 0 ? groups : null;
  };

  const handleRefreshQuotaPerformance = () => {
    if (getPureSpectrumStatsState.apiState !== 'loading') {
      getPureSpectrumStats(id);
    }
  };

  const HEALTH_ALERT_LABELS = {
    completes_per_hour: 'Completes Per Hour',
    pace: 'Pace',
    buyer_drop_rate: 'Buyer Drop Rate',
    buyer_over_quota: 'Buyer Over Quota',
    ps_status_ratio: 'PS Status Ratio',
    supplier_dominance: 'Supplier Dominance',
    too_good_to_be_true: 'Too Good to be True',
    ir_delta: 'IR Delta',
    loi_delta: 'LOI Delta',
  };

  const HEALTH_STATUS_LABELS = {
    green: 'Currently Healthy',
    red: 'Needs Attention',
    yellow: 'Warning',
    grey: 'Collecting Data',
  };

  const HEALTH_ALERT_REASONS = {
    completes_per_hour: 'In the last hour, this survey has seen few or no completes in the last hour.',
    pace: 'We calculate expected pace by looking at the average amount of traffic for every hour in a given region and compare that to the actual completes gathered in a survey over the course of the projected field time.',
    buyer_drop_rate: 'Percentage of respondents who started but did not complete the survey on the buyer side.',
    buyer_over_quota: 'Percentage of respondents who completed the survey but were over quota.',
    ps_status_ratio: 'Percentage of transactions resulting in a PureSpectrum status.',
    supplier_dominance: 'Percentage of completes coming from a single supplier.',
    too_good_to_be_true: 'One or more suppliers\' IR is higher than the average IR of other suppliers in this survey.',
    ir_delta: 'Next calculation will run after enough transactions are captured.',
    loi_delta: 'Next calculation will run after enough transactions are captured.',
  };

  // PS portal display order
  const HEALTH_ALERT_ORDER = [
    'completes_per_hour', 'pace', 'buyer_drop_rate', 'buyer_over_quota',
    'ps_status_ratio', 'supplier_dominance', 'too_good_to_be_true',
    'ir_delta', 'loi_delta',
  ];

  const getHealthChecks = () => {
    if (!psStats?.health_checks || !Array.isArray(psStats.health_checks)) return null;
    if (psStats.health_checks.length === 0) return null;
    // Sort to match PS portal order
    return [...psStats.health_checks].sort((a, b) => {
      const keyA = (a.health_alert || '').toLowerCase().replace(/\s+/g, '_');
      const keyB = (b.health_alert || '').toLowerCase().replace(/\s+/g, '_');
      const idxA = HEALTH_ALERT_ORDER.indexOf(keyA);
      const idxB = HEALTH_ALERT_ORDER.indexOf(keyB);
      return (idxA === -1 ? 999 : idxA) - (idxB === -1 ? 999 : idxB);
    });
  };

  // Get overall survey performance from PS survey performance endpoint
  const getSurveyPerf = () => psStats?.survey_performance || null;

  // Handle save template response
  useEffect(() => {
    if (saveCampaignTemplateState.apiState === 'success') {
      notification.success({
        message: 'Template saved successfully',
      });
      setSaveTemplateModalVisible(false);
      setTemplateName('');
      saveCampaignTemplateReset();
    } else if (saveCampaignTemplateState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description: saveCampaignTemplateState.message || 'Failed to save template',
      });
      saveCampaignTemplateReset();
    }
  }, [saveCampaignTemplateState.apiState]);

  const handleSaveAsTemplate = () => {
    if (!templateName.trim() || !campaign) return;

    const templateData = {
      study_type: campaign.study_type,
      topic: campaign.topic || null,
      country: campaign.country || 'US',
      age_min: campaign.age_min ?? null,
      age_max: campaign.age_max ?? null,
      language: campaign.language || null,
      gender: campaign.gender || [],
      race: campaign.race || [],
      state: campaign.state || [],
      dma: campaign.dma || [],
      region: campaign.region || [],
      division: campaign.division || [],
      msa: campaign.msa || [],
      csa: campaign.csa || [],
      county: campaign.county || [],
      zipcode: campaign.zipcode || [],
      polling_agent_id: campaign.polling_agent_id?._id || campaign.polling_agent_id || null,
      survey_message: campaign.survey_message || '',
      income_min: campaign.income_min ?? null,
      income_max: campaign.income_max ?? null,
      education: campaign.education || [],
      employment: campaign.employment || [],
      children: campaign.children || [],
      relationship: campaign.relationship || [],
      hispanic_origin: campaign.hispanic_origin || [],
      device: campaign.device || [],
      advanced_targeting: (campaign.advanced_targeting || []).map(at => ({
        qualification_code: at.qualification_code,
        qualification_name: at.qualification_name,
        question_text: at.question_text,
        condition_codes: at.condition_codes,
        selected_labels: at.selected_labels,
      })),
      quotas: campaign.quotas || {},
      nested_quotas: campaign.nested_quotas || {},
      responses: campaign.responses ?? null,
      duration: campaign.duration ?? null,
      survey_duration: campaign.survey_duration ?? null,
      cpi: campaign.cpi ?? null,
      qualifying_rate: campaign.qualifying_rate ?? null,
      field_evenly: can('field-evenly') ? (campaign.field_evenly === true) : false,
      feot_is_custom: campaign.feot_is_custom === true,
      feot_pacing: campaign.feot_pacing || null,
      feot_interval: campaign.feot_interval || null,
    };

    saveCampaignTemplate({
      template_name: templateName.trim(),
      form_data: templateData,
    });
  };

  return (
    <>
      <MobHeader />
      <ThemeMainWrapper className="campaign-detail-wrapper">
        <HeaderSection className="noBackground">
          <HeaderLeft>
            <ThemeFilterBtn
              classNames="btnGrayBorder"
              size="medium"
              icon={<img src="/images/back-icon.svg" alt="Back" />}
              className="noBackground mr-2"
              onClick={() => navigate(getBackUrl())}
            />

            <CampaignTitleWrapper>
              <CampaignTitle>{campaign?.campaign_name || (isFetchingCampaign ? '' : '-')}</CampaignTitle>
            </CampaignTitleWrapper>
          </HeaderLeft>
          <HeaderRight>
            {/* Eleven Labs Credits - Super Admin OR Permission */}
            {(isSuperAdmin || can('view-elevenlabs-credits')) && getElevenLabsCreditsState.apiState === 'loading' && (
              <div style={{ marginRight: '16px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <div style={{ borderRadius: 4, width: 80, height: 12, background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.4s ease infinite' }} />
                <div style={{ borderRadius: 4, width: 200, height: 12, background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)', backgroundSize: '200% 100%', animation: 'shimmer 1.4s ease infinite' }} />
                <style>{`@keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }`}</style>
              </div>
            )}
            {(isSuperAdmin || can('view-elevenlabs-credits')) && getElevenLabsCreditsState.apiState === 'success' && getElevenLabsCreditsState.data && (() => {
              const remaining = getElevenLabsCreditsState.data.character_limit - getElevenLabsCreditsState.data.character_count;
              const usedPercent = Math.round((getElevenLabsCreditsState.data.character_count / getElevenLabsCreditsState.data.character_limit) * 100);
              const remainingPercent = 100 - usedPercent;
              return (
                <div style={{
                  marginRight: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}>
                  <Tooltip title={`${usedPercent}% used | ${remainingPercent}% remaining`}>
                    <Progress
                      type="circle"
                      percent={usedPercent}
                      size={36}
                      strokeColor="#3D2969"
                      trailColor="#e8e8e8"
                      format={(percent) => <span style={{ fontSize: '9px', fontWeight: 600, color: '#3D2969' }}>{percent}%</span>}
                    />
                  </Tooltip>
                  <div style={{ fontSize: '11px', lineHeight: '1.5' }}>
                    <div style={{ fontWeight: 600, color: '#3D2969' }}>Call Credits</div>
                    <div>
                      <span style={{ color: '#999' }}>Total: </span>
                      <span style={{ fontWeight: 500, color: '#3D2969' }}>
                        {getElevenLabsCreditsState.data.character_limit?.toLocaleString()}
                      </span>
                      <span style={{ color: '#ccc', margin: '0 5px' }}>&middot;</span>
                      <span style={{ color: '#999' }}>Remaining: </span>
                      <span style={{ fontWeight: 500, color: '#3D2969' }}>
                        {remaining?.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })()}
            {campaign && can('save-template') && (
              <ThemeButton
                className="noBackground"
                size="large"
                icon={<SaveOutlined />}
                onClick={() => setSaveTemplateModalVisible(true)}
              >
                <span>Export as Template</span>
              </ThemeButton>
            )}
            {campaign && can('edit') && campaign.status !== 'completed' && campaign.status !== 'closed' && (
              <ThemeButton className="noBackground" size="large" icon={<EditOutlined />} onClick={handleEdit}>
                <span>Edit</span>
              </ThemeButton>
            )}
            {campaign && can('publish') && canPublish() && (
              <ThemeButton
                size="large"
                onClick={handlePublishToPureSpectrum}
                loading={publishToPureSpectrumState.apiState === 'loading'}
                disabled={publishToPureSpectrumState.apiState === 'loading'}
              >
                <span>Publish</span>
              </ThemeButton>
            )}
          </HeaderRight>
        </HeaderSection>
        <ContentWrapper>
          {(isFetchingCampaign || campaign) && (
            <Row gutter={[16,16]}>
              {/* PureSpectrum Card - Only show for purespectrum study type with ps_survey_id and permission */}
              {(isFetchingCampaign || (isPureSpectrum && campaign?.ps_survey_id && can('purespectrum'))) && (
              <Col xs={24} md={12} lg={12} xl={12}>
                <HeaderInfoCard title="System Managed" loading={isFetchingCampaign}>
                        {campaign && (
                          <>
                            {campaign.ps_last_synced_at && (
                              (() => {
                                const statusConfig = getStudyDetailStatusConfig(campaign.status || 'saved');
                                return (
                                  <PureSpectrumCard
                                    className="mb-4"
                                    style={{
                                      background: statusConfig.cardBackground,
                                      border: `1px solid ${statusConfig.cardBorder}`,
                                    }}
                                  >
                                    <Row gutter={[16, 16]} align="middle" justify="space-between">
                                      <Col flex="auto">
                                        <h3>Study</h3>
                                        <p>Last Synced : <span>{formatDateTime(campaign.ps_last_synced_at)}</span></p>
                                      </Col>
                                      <Col>
                                        <StatusBadgeWrapper
                                          style={{
                                            backgroundColor: '#FFFFFF',
                                            color: statusConfig.color,
                                            border: `1px solid ${statusConfig.cardBorder}`,
                                          }}
                                        >
                                          <span className="status-icon">{getStudyDetailStatusIcon(campaign.status)}</span>
                                          <span>{statusConfig.text}</span>
                                        </StatusBadgeWrapper>
                                      </Col>
                                    </Row>
                                  </PureSpectrumCard>
                                );
                              })()
                            )}
                            <SectionDivider />
                            {campaign.ps_survey_id && (
                              <div className="justifyBetween mb-5" align="center">
                                <div className="title">Survey ID</div>
                                <div className="value">{campaign.ps_survey_id}</div>
                              </div>
                            )}
                            {campaign.responses != null && (
                              <div className="justifyBetween mb-5" align="center">
                                <div className="title">Responses</div>
                                <div className="value">{campaign.responses.toLocaleString()}</div>
                              </div>
                            )}
                            {getSurveyPerf() && can('quota-performance') && (
                              <div className="justifyBetween mb-5" align="center">
                                <div className="title">Fielded vs Goal</div>
                                <div className="value">
                                  {getSurveyPerf().completes_fielded} | {getSurveyPerf().completes_goal}
                                </div>
                              </div>
                            )}
                            {getSurveyPerf() && can('quota-performance') && (
                              <div className="justifyBetween mb-5" align="center">
                                <div className="title">Total Cost</div>
                                <div className="value">
                                  ${parseFloat(getSurveyPerf().current_cost || 0).toFixed(2)}
                                </div>
                              </div>
                            )}
                            {campaign.ps_survey_id && can('cpi') && (
                              <div className="justifyBetween mb-5" align="center">
                                <div className="title">Cost Per Interview (CPI)</div>
                                <div className="value" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  {isEditingCPI ? (
                                    <>
                                      <InputNumber
                                        value={cpiValue}
                                        onChange={(value) => setCpiValue(value)}
                                        min={0}
                                        step={0.01}
                                        precision={2}
                                        prefix="$"
                                        style={{ width: '120px' }}
                                        disabled={updateCPIState.apiState === 'loading'}
                                      />
                                      <Tooltip title="Save">
                                        <CheckOutlined
                                          style={{
                                            fontSize: '14px',
                                            color: '#52c41a',
                                            cursor: updateCPIState.apiState === 'loading' ? 'not-allowed' : 'pointer',
                                            opacity: updateCPIState.apiState === 'loading' ? 0.6 : 1,
                                          }}
                                          onClick={updateCPIState.apiState === 'loading' ? null : handleSaveCPI}
                                        />
                                      </Tooltip>
                                      <Tooltip title="Cancel">
                                        <CloseCircleOutlined
                                          style={{
                                            fontSize: '14px',
                                            color: '#ff4d4f',
                                            cursor: updateCPIState.apiState === 'loading' ? 'not-allowed' : 'pointer',
                                            opacity: updateCPIState.apiState === 'loading' ? 0.6 : 1,
                                          }}
                                          onClick={updateCPIState.apiState === 'loading' ? null : handleCancelEditCPI}
                                        />
                                      </Tooltip>
                                    </>
                                  ) : (
                                    <>
                                      <span style={{ color: campaign.cpi ? '#000' : '#999' }}>
                                        {campaign.cpi !== null && campaign.cpi !== undefined ? `$${campaign.cpi.toFixed(2)}` : 'Not set'}
                                      </span>
                                      {canEditCPI() && (
                                        <Tooltip title="Edit CPI">
                                          <EditOutlined
                                            style={{ fontSize: '14px', color: '#3D2969', cursor: 'pointer' }}
                                            onClick={handleStartEditCPI}
                                          />
                                        </Tooltip>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            )}
                            {campaign.field_evenly && can('field-evenly') && (
                              <div className="justifyBetween mb-5" align="center">
                                <div className="title">Field Evenly</div>
                                <div className="value">
                                  <div>
                                    {campaign.feot_is_custom
                                      ? `Custom — ${campaign.feot_pacing ? campaign.feot_pacing.charAt(0).toUpperCase() + campaign.feot_pacing.slice(1) : 'N/A'}${campaign.feot_interval ? `, every ${campaign.feot_interval}` : ''}`
                                      : 'Daily'}
                                  </div>
                                  {campaign.responses > 0 && campaign.duration > 0 && (() => {
                                    const remaining = campaign.feot_is_custom && campaign.feot_pacing
                                      ? (campaign.feot_pacing === 'hours' ? campaign.duration * 24 : campaign.feot_pacing === 'weeks' ? Math.ceil(campaign.duration / 7) : campaign.duration)
                                      : campaign.duration;
                                    const perUnit = Math.round(campaign.responses / Math.max(1, remaining));
                                    const unit = campaign.feot_is_custom && campaign.feot_pacing
                                      ? (campaign.feot_pacing === 'hours' ? 'hour' : campaign.feot_pacing === 'weeks' ? 'week' : 'day')
                                      : 'day';
                                    const units = campaign.feot_is_custom && campaign.feot_pacing
                                      ? (campaign.feot_pacing === 'hours' ? 'hours' : campaign.feot_pacing === 'weeks' ? 'weeks' : 'days')
                                      : 'days';
                                    return <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 2 }}>{perUnit} {perUnit <= 1 ? 'complete' : 'completes'} per {unit} for {remaining} remaining {units} in field.</div>;
                                  })()}
                                </div>
                              </div>
                            )}
                            {campaign.survey_duration != null && (
                              <div className="justifyBetween mb-5" align="center">
                                <div className="title">Length (mins)</div>
                                <div className="value">{campaign.survey_duration} mins</div>
                              </div>
                            )}
                            {campaign.qualifying_rate != null && can('incidence') && (
                              <div className="justifyBetween mb-5" align="center">
                                <div className="title">Incidence</div>
                                <div className="value">{campaign.qualifying_rate}%</div>
                              </div>
                            )}
                            {campaign.duration != null && (
                              <div className="justifyBetween mb-5" align="center">
                                <div className="title">Field Time</div>
                                <div className="value">{campaign.duration} days</div>
                              </div>
                            )}
                            {(campaign.ps_test_link || campaign.ps_live_url) && campaign.status !== 'completed' && (
                              <>
                              {campaign.ps_test_link && (
                                <div className="justifyBetween mb-5" align="center">
                                  <div className="title">Test Link</div>
                                  <div className="value" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Tooltip title="Copy link">
                                      <CopyOutlined
                                        style={{ fontSize: '14px', color: '#3D2969', cursor: 'pointer' }}
                                        onClick={() => {
                                          navigator.clipboard.writeText(campaign.ps_test_link);
                                          notification.success({ message: 'Link copied to clipboard' });
                                        }}
                                      />
                                    </Tooltip>
                                    <a href={campaign.ps_test_link} target="_blank" rel="noopener noreferrer" style={{ color: '#3D2969', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                      <LinkOutlined style={{ fontSize: '14px' }} /> Open Test Link
                                    </a>
                                  </div>
                                </div>
                              )}
                              {/* {campaign.ps_live_url && (
                                <div className="justifyBetween mb-5" align="center">
                                  <div className="title">Live Link</div>
                                  <div className="value" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Tooltip title="Copy link">
                                      <CopyOutlined
                                        style={{ fontSize: '14px', color: '#3D2969', cursor: 'pointer' }}
                                        onClick={() => {
                                          navigator.clipboard.writeText(campaign.ps_live_url);
                                          notification.success({ message: 'Link copied to clipboard' });
                                        }}
                                      />
                                    </Tooltip>
                                    <a href={campaign.ps_live_url} target="_blank" rel="noopener noreferrer" style={{ color: '#3D2969', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                      <LinkOutlined style={{ fontSize: '14px' }} /> Open Live Link
                                    </a>
                                  </div>
                                </div>
                              )} */}
                            </>
                            )}
                            {can('sync') && canSync() && (
                              <div className="justifyBetween mb-5" align="center">
                                <div className="title">Sync Study</div>
                                <div className="value">
                                  <span
                                    onClick={syncCampaignState.apiState === 'loading' ? null : handleSyncCampaign}
                                    style={{
                                      color: '#3D2969',
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '6px',
                                      cursor: syncCampaignState.apiState === 'loading' ? 'not-allowed' : 'pointer',
                                      opacity: syncCampaignState.apiState === 'loading' ? 0.6 : 1,
                                    }}
                                  >
                                    <SyncOutlined spin={syncCampaignState.apiState === 'loading'} style={{ fontSize: '14px' }} /> Sync Now
                                  </span>
                                </div>
                              </div>
                            )}
                            {campaign.ps_survey_id && campaign.status !== 'completed' && (
                              <div className="justifyBetween mb-5" align="center">
                                <div className="title">Sync Status</div>
                                <div className="value">{getSyncStatusTag(campaign.ps_sync_status || 'not_synced')}</div>
                              </div>
                            )}
                            <div style={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap', gap: '12px' }}>
                              {can('pause') && canPause() && (
                                <ThemeButton
                                  size="large"
                                  className="primary"
                                  icon={<PauseCircleOutlined />}
                                  onClick={handlePauseCampaign}
                                  loading={pauseCampaignState.apiState === 'loading'}
                                >
                                  Pause Study
                                </ThemeButton>
                              )}

                              {can('resume') && canResume() && (
                                <ThemeButton
                                  size="large"
                                  icon={<PlayCircleOutlined />}
                                  onClick={handleResumeCampaign}
                                  loading={resumeCampaignState.apiState === 'loading'}
                                >
                                  Resume Study
                                </ThemeButton>
                              )}

                              {can('close') && canClose() && (
                                <ThemeButton
                                  size="large"
                                  className="danger"
                                  icon={<CloseCircleOutlined />}
                                  onClick={handleCloseCampaign}
                                  loading={closeCampaignState.apiState === 'loading'}
                                >
                                  Close Study
                                </ThemeButton>
                              )}

                              {can('launch') && canLaunch() && (
                                <ThemeButton
                                  size="large"
                                  icon={<RocketOutlined />}
                                  onClick={handleLaunchCampaign}
                                  loading={launchCampaignState.apiState === 'loading'}
                                >
                                  Launch Study
                                </ThemeButton>
                              )}

                              {can('force-close') && canForceClose() && (
                                <ThemeButton
                                  size="large"
                                  className="danger"
                                  icon={<WarningOutlined />}
                                  onClick={() => setConfirmModal({ visible: true, type: 'force-close' })}
                                  loading={forceCloseCampaignState.apiState === 'loading'}
                                >
                                  Force Close
                                </ThemeButton>
                              )}
                            </div>
                          </>
                        )}
                      </HeaderInfoCard>
                    </Col>
                    )}
                    {/* Email Invites Card - Only show for email-invite study type with permission */}
                    {campaign && isEmailInvite && can('email-invites') && (
                    <Col xs={24} md={12} lg={12} xl={12}>
                      <HeaderInfoCard
                        title="Custom Upload"
                        loading={isFetchingCampaign}
                        extra={
                          <ThemeButton
                            className="noBackground"
                            size="small"
                            icon={<DownloadOutlined />}
                            onClick={() => window.open(`${config.api.base_url}/email-invites/sample`, '_blank')}
                            style={{ height: '24px', padding: '0 8px', fontSize: '11px', lineHeight: '24px' }}
                          >
                            Download Template
                          </ThemeButton>
                        }
                      >
                        <EmailInviteSection
                          campaignId={id}
                          campaign={campaign}
                          canUpload={can('upload-email-invites') && campaign.status !== 'completed' && campaign.status !== 'closed'}
                          canResend={can('resend-email-invites') && campaign.status !== 'completed' && campaign.status !== 'closed'}
                          canBulkResend={can('bulk-resend-email-invites') && campaign.status !== 'completed' && campaign.status !== 'closed'}
                          canDelete={can('delete-email-invites')}
                          canLaunch={can('launch') && canLaunch()}
                          canPause={can('pause') && canPause()}
                          canResume={can('resume') && canResume()}
                          canClose={can('close') && canClose()}
                          onLaunch={handleLaunchCampaign}
                          onPause={handlePauseCampaign}
                          onResume={handleResumeCampaign}
                          onClose={handleCloseCampaign}
                          launchLoading={launchCampaignState.apiState === 'loading'}
                          pauseLoading={pauseCampaignState.apiState === 'loading'}
                          resumeLoading={resumeCampaignState.apiState === 'loading'}
                          closeLoading={closeCampaignState.apiState === 'loading'}
                        />
                      </HeaderInfoCard>
                    </Col>
                    )}
                    <Col xs={24} md={12} lg={12} xl={12}>
                      <HeaderInfoCard title={
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <span>Target Audience</span>
                          {campaign && campaign.responses != null && !campaign.ps_survey_id && (
                            <span style={{ fontSize: 14, fontWeight: 500, color: '#374151' }}>
                              Responses: {campaign.responses.toLocaleString()}
                            </span>
                          )}
                        </div>
                      } loading={isFetchingCampaign}>
                        {campaign && (
                          <>
                            <Row gutter={[16, 16]} className="mt-2">
                              <Col xs={24} className="mb-5">
                                <TargetAudienceCard>
                                  <div className="leftIcon background">
                                    <img className="img-fluid" src="/images/sound-icon.svg" alt="Topic" />
                                  </div>
                                  <div className="rightContent">
                                    <CampaignTitle>{campaign.campaign_name || '-'}</CampaignTitle>
                                    <CampaignSubtitle>
                                      {getAgentName()}  |  {formatDate(campaign.createdAt)}
                                    </CampaignSubtitle>
                                  </div>
                                </TargetAudienceCard>
                              </Col>
                            </Row>
                            <SectionDivider />
                            <Row gutter={[16, 16]}>
                              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TargetAudienceCard>
                                  <div className="leftIcon">
                                    <img src="/images/topic-icon.svg" alt="Topic" />
                                  </div>
                                  <div className="rightContent">
                                    <div className="title">Topic</div>
                                    <div className="value">{campaign.topic || '-'}</div>
                                  </div>
                                </TargetAudienceCard>
                              </Col>
                              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TargetAudienceCard>
                                  <div className="leftIcon">
                                    <img src="/images/language-icon.svg" alt="Topic" />
                                  </div>
                                  <div className="rightContent">
                                    <div className="title">Language</div>
                                    <div className="value">{formatSentenceValue(campaign.language)}</div>
                                  </div>
                                </TargetAudienceCard>
                              </Col>
                              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TargetAudienceCard>
                                  <div className="leftIcon">
                                    <img src="/images/country-icon.svg" alt="Topic" />
                                  </div>
                                  <div className="rightContent">
                                    <div className="title">Country</div>
                                    <div className="value">{formatSentenceValue(campaign.country)}</div>
                                  </div>
                                </TargetAudienceCard>
                              </Col>

                              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TargetAudienceCard>
                                  <div className="leftIcon">
                                    <img src="/images/country-icon.svg" alt="Topic" />
                                  </div>
                                  <div className="rightContent">
                                    <div className="title">{
                                      campaign.region?.length > 0 ? 'Region'
                                      : campaign.division?.length > 0 ? 'Division'
                                      : campaign.state?.length > 0 ? 'State'
                                      : campaign.msa?.length > 0 ? 'MSA / CBSA'
                                      : campaign.csa?.length > 0 ? 'CSA'
                                      : campaign.county?.length > 0 ? 'County'
                                      : campaign.zipcode?.length > 0 ? 'Zipcode'
                                      : campaign.dma?.length > 0 ? 'DMA'
                                      : 'Location'
                                    }</div>
                                    <div className="value">{
                                      campaign.region?.length > 0 ? formatSentenceValue(campaign.region)
                                      : campaign.division?.length > 0 ? formatSentenceValue(campaign.division)
                                      : campaign.state?.length > 0 ? formatSentenceValue(campaign.state)
                                      : campaign.msa?.length > 0 ? formatSentenceValue(campaign.msa)
                                      : campaign.csa?.length > 0 ? formatSentenceValue(campaign.csa)
                                      : campaign.county?.length > 0 ? formatSentenceValue(campaign.county)
                                      : campaign.zipcode?.length > 0 ? formatSentenceValue(campaign.zipcode)
                                      : campaign.dma?.length > 0 ? formatSentenceValue(campaign.dma)
                                      : '-'
                                    }</div>
                                  </div>
                                </TargetAudienceCard>
                              </Col>
                              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                <TargetAudienceCard>
                                  <div className="leftIcon">
                                    <img src="/images/age-icon.svg" alt="Topic" />
                                  </div>
                                  <div className="rightContent">
                                    <div className="title">Age</div>
                                    <div className="value">
                                      {campaign.age_min || campaign.age_max
                                      ? `${campaign.age_min || ''}${campaign.age_min && campaign.age_max ? ' - ' : ''}${campaign.age_max || ''}`
                                      : '-'}
                                      </div>
                                  </div>
                                  </TargetAudienceCard>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                  <TargetAudienceCard>
                                    <div className="leftIcon">
                                      <img src="/images/gender-icon.svg" alt="Topic" />
                                    </div>
                                    <div className="rightContent">
                                      <div className="title">Gender</div>
                                      <div className="value">{formatSentenceValue(campaign.gender)}</div>
                                    </div>
                                  </TargetAudienceCard>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                  <TargetAudienceCard>
                                    <div className="leftIcon">
                                      <img src="/images/age-icon.svg" alt="Topic" />
                                    </div>
                                    <div className="rightContent">
                                      <div className="title">Race / Ethnicity</div>
                                      <div className="value">{formatSentenceValue(campaign.race)}</div>
                                    </div>
                                  </TargetAudienceCard>
                                </Col>
{/* New demographic fields */}
                                {(campaign.hispanic_origin?.length > 0) && (
                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                  <TargetAudienceCard>
                                    <div className="leftIcon">
                                      <img src="/images/age-icon.svg" alt="Hispanic Origin" />
                                    </div>
                                    <div className="rightContent">
                                      <div className="title">Hispanic Origin</div>
                                      <div className="value">{formatSentenceValue(campaign.hispanic_origin)}</div>
                                    </div>
                                  </TargetAudienceCard>
                                </Col>
                                )}
                                {(campaign.income_min || campaign.income_max) && (
                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                  <TargetAudienceCard>
                                    <div className="leftIcon">
                                      <img src="/images/responses-icon.svg" alt="Income" />
                                    </div>
                                    <div className="rightContent">
                                      <div className="title">Household Income</div>
                                      <div className="value">
                                        {campaign.income_min != null && campaign.income_max != null
                                          ? `$${campaign.income_min.toLocaleString()} - $${campaign.income_max.toLocaleString()}`
                                          : campaign.income_min != null
                                            ? `$${campaign.income_min.toLocaleString()}+`
                                            : campaign.income_max != null
                                              ? `Up to $${campaign.income_max.toLocaleString()}`
                                              : '-'}
                                      </div>
                                    </div>
                                  </TargetAudienceCard>
                                </Col>
                                )}
                                {(campaign.education?.length > 0) && (
                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                  <TargetAudienceCard>
                                    <div className="leftIcon">
                                      <img src="/images/age-icon.svg" alt="Education" />
                                    </div>
                                    <div className="rightContent">
                                      <div className="title">Education</div>
                                      <div className="value">{formatSentenceValue(campaign.education)}</div>
                                    </div>
                                  </TargetAudienceCard>
                                </Col>
                                )}
                                {(campaign.employment?.length > 0) && (
                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                  <TargetAudienceCard>
                                    <div className="leftIcon">
                                      <img src="/images/age-icon.svg" alt="Employment" />
                                    </div>
                                    <div className="rightContent">
                                      <div className="title">Employment</div>
                                      <div className="value">{formatSentenceValue(campaign.employment)}</div>
                                    </div>
                                  </TargetAudienceCard>
                                </Col>
                                )}
                                {(campaign.children?.length > 0) && (
                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                  <TargetAudienceCard>
                                    <div className="leftIcon">
                                      <img src="/images/age-icon.svg" alt="Children" />
                                    </div>
                                    <div className="rightContent">
                                      <div className="title">Children</div>
                                      <div className="value">{formatSentenceValue(campaign.children)}</div>
                                    </div>
                                  </TargetAudienceCard>
                                </Col>
                                )}
                                {(campaign.relationship?.length > 0) && (
                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                  <TargetAudienceCard>
                                    <div className="leftIcon">
                                      <img src="/images/age-icon.svg" alt="Relationship" />
                                    </div>
                                    <div className="rightContent">
                                      <div className="title">Relationship Status</div>
                                      <div className="value">{formatSentenceValue(campaign.relationship)}</div>
                                    </div>
                                  </TargetAudienceCard>
                                </Col>
                                )}
                                {(campaign.device?.length > 0) && (
                                <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                  <TargetAudienceCard>
                                    <div className="leftIcon">
                                      <img src="/images/age-icon.svg" alt="Device" />
                                    </div>
                                    <div className="rightContent">
                                      <div className="title">Device</div>
                                      <div className="value">{formatSentenceValue(campaign.device)}</div>
                                    </div>
                                  </TargetAudienceCard>
                                </Col>
                                )}
                            </Row>
                          </>
                        )}
                      </HeaderInfoCard>
                    </Col>
                    {/* PS Stats Tabs - Quota Performance & Health Checks */}
                    {campaign && isPureSpectrum && campaign.ps_survey_id &&
                     ['in_progress', 'paused', 'completed', 'closed'].includes(campaign.status) &&
                     (can('quota-performance') || can('health-check')) && (
                      <Col xs={24}>
                          <PsStatsTabs
                            type="card"
                            defaultActiveKey={can('quota-performance') ? 'quotas' : 'health'}
                            tabBarExtraContent={
                              <Tooltip title="Refresh">
                                <ThemeFilterBtn
                                  className="refresh-btn"
                                  icon={<ReloadOutlined />}
                                  onClick={handleRefreshQuotaPerformance}
                                  loading={getPureSpectrumStatsState.apiState === 'loading'}
                                />
                              </Tooltip>
                            }
                            items={[
                              can('quota-performance') && {
                                key: 'quotas',
                                label: 'Quota Performance',
                                children: (
                                  <>
                                    {getPureSpectrumStatsState.apiState === 'loading' && !psStats && (
                                      <div style={{ textAlign: 'center', padding: '24px' }}>
                                        <Spin tip="Loading quota performance..." />
                                      </div>
                                    )}
                                    {getPureSpectrumStatsState.apiState === 'error' && !psStats && (
                                      <div style={{ padding: '16px' }}>
                                        <Alert
                                          type="warning"
                                          message="Unable to load quota performance"
                                          description="Quota data could not be fetched from PureSpectrum."
                                          action={
                                            <ThemeButton size="small" onClick={handleRefreshQuotaPerformance}>
                                              Retry
                                            </ThemeButton>
                                          }
                                        />
                                      </div>
                                    )}
                                    {psStats && (() => {
                                      const groups = buildQuotaPerformanceFromPS();
                                      if (!groups) {
                                        return (
                                          <div style={{ padding: '24px', color: '#999', textAlign: 'center', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            Survey has no quotas
                                          </div>
                                        );
                                      }

                                      const allEntries = Object.entries(groups);
                                      const regularGroups = allEntries.filter(([label]) => !label.startsWith('Interlocked:'));
                                      const interlockedGroups = allEntries.filter(([label]) => label.startsWith('Interlocked:'));
                                      const sortedGroups = [...regularGroups, ...interlockedGroups];

                                      return (
                                        <div style={{ padding: '16px' }}>
                                          <Row gutter={[16, 16]}>
                                            {sortedGroups.map(([fieldLabel, entries]) => (
                                              <Col xs={24} md={fieldLabel.startsWith('Interlocked:') ? 24 : 12} key={fieldLabel}>
                                                <QuotaFieldCard className={fieldLabel.startsWith('Interlocked:') ? 'interlocked' : ''}>
                                                  <div className="field-card-header">
                                                    <span className="field-name">{fieldLabel}</span>
                                                    <span className="col-header">Fielded Vs Goal</span>
                                                    <span className="col-header">Target</span>
                                                    <span className="col-header">Open</span>
                                                    <span className="col-header">Progress</span>
                                                  </div>
                                                  <div className="field-card-body">
                                                    {entries.map((entry, idx) => (
                                                      <QuotaRow key={entry.buyerQuotaId || idx}>
                                                        <span className="row-label" title={entry.label}>{entry.label}</span>
                                                        <div className="row-fielded-goal">
                                                          <span className="fielded">{entry.fielded}</span>
                                                          <span className="separator">|</span>
                                                          <span className="goal">{entry.goal}</span>
                                                        </div>
                                                        <span className="row-target">{entry.goal}</span>
                                                        <span className="row-currently-open">{entry.currentlyOpen}</span>
                                                        <Tooltip title={`${entry.percentage}%`}>
                                                          <div className="row-progress">
                                                            <Progress
                                                              percent={entry.percentage}
                                                              size="small"
                                                              strokeColor={entry.isComplete ? '#48B569' : '#1890ff'}
                                                              trailColor="#E2E8EE"
                                                              showInfo={false}
                                                            />
                                                          </div>
                                                        </Tooltip>
                                                      </QuotaRow>
                                                    ))}
                                                  </div>
                                                </QuotaFieldCard>
                                              </Col>
                                            ))}
                                          </Row>
                                        </div>
                                      );
                                    })()}
                                  </>
                                ),
                              },
                              can('health-check') && {
                                key: 'health',
                                label: 'Health Checks',
                                children: (
                                  <>
                                    {getPureSpectrumStatsState.apiState === 'loading' && !psStats && (
                                      <div style={{ textAlign: 'center', padding: '24px' }}>
                                        <Spin tip="Loading health checks..." />
                                      </div>
                                    )}
                                    {getPureSpectrumStatsState.apiState === 'error' && !psStats && (
                                      <div style={{ padding: '16px' }}>
                                        <Alert
                                          type="warning"
                                          message="Unable to load health checks"
                                          description="Health data could not be fetched from PureSpectrum."
                                          action={
                                            <ThemeButton size="small" onClick={handleRefreshQuotaPerformance}>
                                              Retry
                                            </ThemeButton>
                                          }
                                        />
                                      </div>
                                    )}
                                    {psStats && (() => {
                                      const healthData = getHealthChecks();
                                      if (!healthData) {
                                        return (
                                          <div style={{ padding: '24px', color: '#999', textAlign: 'center', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            No health check data available
                                          </div>
                                        );
                                      }

                                      return (
                                        <div style={{ maxHeight: 400, overflowY: 'auto', scrollbarWidth: 'thin', scrollbarColor: 'rgba(0,0,0,0.15) transparent' }}>
                                          <HealthCheckHeader>
                                            <span>Health Metrics</span>
                                            <span>Status</span>
                                            <span>Value</span>
                                            <span>Reason</span>
                                            <span>Recommendation</span>
                                          </HealthCheckHeader>
                                          {healthData.map((item, idx) => {
                                            const level = (item.alert_level || '').toLowerCase();
                                            const alertKey = (item.health_alert || '').toLowerCase().replace(/\s+/g, '_');
                                            const label = HEALTH_ALERT_LABELS[alertKey] || item.health_alert;
                                            const reason = HEALTH_ALERT_REASONS[alertKey] || '';

                                            return (
                                              <HealthCheckRow key={idx}>
                                                <span className="metric-name">{label}</span>
                                                <span className={`status-badge ${level}`}>
                                                  <span className="status-dot" />
                                                  {HEALTH_STATUS_LABELS[level] || item.alert_level}
                                                </span>
                                                <span className="metric-value">{item.survey_health_metric_value || '—'}</span>
                                                <span className="reason-text">{reason || '—'}</span>
                                                <span className={item.recommendation?.length > 0 ? 'recommendation-text' : 'no-recommendation'}>
                                                  {item.recommendation?.length > 0
                                                    ? item.recommendation.join(' ')
                                                    : '—'}
                                                </span>
                                              </HealthCheckRow>
                                            );
                                          })}
                                        </div>
                                      );
                                    })()}
                                  </>
                                ),
                              },
                            ].filter(Boolean)}
                          />
                      </Col>
                    )}
                    {campaign?.survey_message && (() => {
                      // Survey is 12 cols when both Purespectrum AND Email are visible (so Target+Survey share row 2)
                      // Survey is 24 cols (full width) when only one or neither is visible (Target is next to one of them)
                      const hasPurespectrum = isPureSpectrum && !!campaign?.ps_survey_id && can('purespectrum');
                      const hasEmailInvites = isEmailInvite && can('email-invites');
                      const bothVisible = hasPurespectrum && hasEmailInvites;
                      const neitherVisible = !hasPurespectrum && !hasEmailInvites;
                      const surveyWidth = (bothVisible || neitherVisible) ? 12 : 24;

                      return (
                        <Col xs={24} md={surveyWidth} lg={surveyWidth} xl={surveyWidth}>
                          <HeaderInfoCard title="Study Message" loading={isFetchingCampaign}>
                            <SurveyMessageContent dangerouslySetInnerHTML={{ __html: campaign.survey_message }} />
                          </HeaderInfoCard>
                        </Col>
                      );
                    })()}
                  </Row>
                )}



                {/* <SectionDivider />
                <InfoCardsRow gutter={[23, 20]}>
                  <Col xs={24} sm={12} md={12} lg={8}>
                    <InfoCard>
                      <InfoIconWrapper>
                        <CalendarOutlined />
                      </InfoIconWrapper>
                      <InfoContent>
                        <InfoLabel>Updated On</InfoLabel>
                        <InfoValue>{formatDate(campaign.updatedAt)}</InfoValue>
                      </InfoContent>
                    </InfoCard>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={8}>
                    <InfoCard>
                      <InfoIconWrapper>
                        <UserOutlined />
                      </InfoIconWrapper>
                      <InfoContent>
                        <InfoLabel>Created By</InfoLabel>
                        <InfoValue>{getUserName(campaign.created_by)}</InfoValue>
                      </InfoContent>
                    </InfoCard>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={8}>
                    <InfoCard>
                      <InfoIconWrapper>
                        <UserOutlined />
                      </InfoIconWrapper>
                      <InfoContent>
                        <InfoLabel>Updated By</InfoLabel>
                        <InfoValue>{getUserName(campaign.updated_by)}</InfoValue>
                      </InfoContent>
                    </InfoCard>
                  </Col>
                </InfoCardsRow> 
                {campaign.campaign_link && (
                  <InfoCardsRow gutter={[23, 20]}>
                    <Col xs={24}>
                      <InfoCard>
                        <InfoIconWrapper>
                          <LinkOutlined />
                        </InfoIconWrapper>
                        <InfoContent>
                          <InfoLabel>Study Link</InfoLabel>
                          <InfoValue style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{ wordBreak: 'break-all' }}>{`${window.location.origin}${campaign.campaign_link}`}</span>
                            <Tooltip title={copyTooltip}>
                              <CopyOutlined
                                style={{ cursor: 'pointer', color: '#3d2969', fontSize: '16px', flexShrink: 0 }}
                                onClick={() => {
                                  navigator.clipboard.writeText(`${window.location.origin}${campaign.campaign_link}`);
                                  setCopyTooltip('Copied to clipboard');
                                  setTimeout(() => setCopyTooltip('Click to copy'), 2000);
                                }}
                              />
                            </Tooltip>
                          </InfoValue>
                        </InfoContent>
                      </InfoCard>
                    </Col>
                  </InfoCardsRow>
                )}*/}


            {/* Call Transcripts Section - Show for both study types */}
            {campaign && can('view-call-transcripts') && (
              <CampaignCallsSection
                campaignId={id}
                onQualityChange={() => getTranscriptStats(id)}
              />
            )}

            {/* Not Found State - only show when not loading and no campaign */}
            {!isFetchingCampaign && !campaign && (
              <div
                style={{
                  minHeight: '400px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: '16px',
                  color: '#1f2430',
                }}
              >
                Study not found
              </div>
            )}
        </ContentWrapper>
      </ThemeMainWrapper>

      {/* Launch Confirmation Modal */}
      <ThemeModal
        title={
          <Space>
            <ExclamationCircleOutlined style={{ color: '#faad14' }} />
            Launch Study
          </Space>
        }
        open={confirmModal.visible && confirmModal.type === 'launch'}
        onOk={handleConfirmAction}
        onCancel={handleCancelConfirm}
        okText="Confirm"
        cancelText="Cancel"
        confirmLoading={launchCampaignState.apiState === 'loading'}
      >
        <p>
          {isPureSpectrum
            ? 'Are you sure you want to launch this study? Once launched, the study will go live and start collecting responses. This action cannot be undone easily.'
            : 'Are you sure you want to launch this study? Once launched, invitations will be sent to all pending respondents and the study will start collecting responses. This action cannot be undone easily.'}
        </p>
      </ThemeModal>

      {/* Force Close Confirmation Modal */}
      <ThemeModal
        title={
          <Space>
            <WarningOutlined style={{ color: '#ff4d4f' }} />
            Force Close Study
          </Space>
        }
        open={confirmModal.visible && confirmModal.type === 'force-close'}
        onOk={handleConfirmAction}
        onCancel={handleCancelConfirm}
        okText="Confirm"
        cancelText="Cancel"
        okButtonProps={{ danger: true }}
        confirmLoading={forceCloseCampaignState.apiState === 'loading'}
      >
        <p>
          Are you sure you want to force close this study? This will close the study only in our system. This action cannot be undone.
        </p>
      </ThemeModal>

      {/* Close Study Modal with Two Options */}
      <ThemeModal
        title={
          <Space>
            <ExclamationCircleOutlined style={{ color: '#faad14' }} />
            Close Study
          </Space>
        }
        open={confirmModal.visible && confirmModal.type === 'close'}
        onCancel={handleCancelConfirm}
        footer={
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', flexWrap: 'nowrap' }}>
            <ThemeButton
              key="cancel"
              className="noBackground"
              onClick={handleCancelConfirm}
              disabled={closeCampaignState.apiState === 'loading' || createProjectFromCampaignState.apiState === 'loading' || isFetchingFreshStats}
            >
              Cancel
            </ThemeButton>
            <ThemeButton
              key="closeOnly"
              className={transcriptStats.good > 0 ? "noBackground" : ""}
              onClick={handleCloseOnly}
              loading={closeCampaignState.apiState === 'loading' && !createProjectAfterClose}
              disabled={closeCampaignState.apiState === 'loading' || createProjectFromCampaignState.apiState === 'loading' || isFetchingFreshStats}
            >
              Close Study
            </ThemeButton>
            {transcriptStats.good > 0 && (
              <ThemeButton
                key="closeAndCreate"
                onClick={handleCloseAndCreateProject}
                loading={(closeCampaignState.apiState === 'loading' && createProjectAfterClose) || createProjectFromCampaignState.apiState === 'loading'}
                disabled={closeCampaignState.apiState === 'loading' || createProjectFromCampaignState.apiState === 'loading' || isFetchingFreshStats || ((isSuperAdmin || canProject('anonymous-demographic-switch')) && !createProjectDemographicFormat)}
              >
                Close & Create Library
              </ThemeButton>
            )}
          </div>
        }
      >
        {isFetchingFreshStats ? (
          <p style={{ color: '#666' }}>Loading transcript data...</p>
        ) : (
          <>
            <p>
              Are you sure you want to close this study? This will mark the study as completed and stop
              all data collection. This action cannot be undone.
            </p>
            {/* Warning when ALL transcripts are unreviewed */}
            {transcriptStats.total > 0 && transcriptStats.good === 0 && transcriptStats.neutral > 0 && (
              <p style={{ marginTop: '16px', marginBottom: 0, lineHeight: 1.6 }}>
                <span style={{ fontWeight: 600, color: '#3D2969' }}>
                  You have {transcriptStats.neutral} unreviewed transcript{transcriptStats.neutral > 1 ? 's' : ''}.
                </span>
                {' '}Mark as "Good" to include in project.{' '}
                <span
                  onClick={handleReviewTranscripts}
                  style={{
                    color: '#3D2969',
                    fontWeight: 600,
                    cursor: 'pointer',
                  }}
                >
                  Review now
                </span>
              </p>
            )}
            {/* When some are good but some are still unreviewed */}
            {transcriptStats.good > 0 && transcriptStats.neutral > 0 && (
              <p style={{ marginTop: '16px', marginBottom: 0, lineHeight: 1.6 }}>
                You have <span style={{ fontWeight: 600, color: '#3D2969' }}>{transcriptStats.neutral} unreviewed transcript{transcriptStats.neutral > 1 ? 's' : ''}</span>.
                {' '}Create project from {transcriptStats.good} reviewed, or{' '}
                <span
                  onClick={handleReviewTranscripts}
                  style={{
                    color: '#3D2969',
                    fontWeight: 600,
                    cursor: 'pointer',
                  }}
                >
                  review now
                </span>
              </p>
            )}
            {/* When all transcripts are reviewed (no neutral) */}
            {transcriptStats.good > 0 && transcriptStats.neutral === 0 && (
              <p style={{ marginTop: '12px', marginBottom: 0, color: '#666' }}>
                You have <span style={{ fontWeight: 600, color: '#3D2969' }}>{transcriptStats.good} good transcript{transcriptStats.good > 1 ? 's' : ''}</span> ready for project creation.
              </p>
            )}
            {/* Demographic Format Selection - shown when good transcripts available and user has permission */}
            {transcriptStats.good > 0 && (isSuperAdmin || canProject('anonymous-demographic-switch')) && (
              <div style={{ marginTop: 16, paddingTop: 12, marginBottom: 16, borderTop: '1px solid #f0f0f0' }}>
                <div style={{ marginBottom: 6 }}>
                  <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 13, fontWeight: 500, color: '#0a1b39' }}>
                    Demographic Display
                  </span>
                  <span style={{ color: '#ff4d4f', marginLeft: 4 }}>*</span>
                  <Tooltip title="This applies to the project created from your transcripts. Controls how demographics (age, location) appear in AI responses.">
                    <InfoCircleOutlined style={{ color: '#999', fontSize: 13, marginLeft: 6, cursor: 'pointer' }} />
                  </Tooltip>
                </div>
                <div style={{ fontSize: 11, color: '#666', marginBottom: 8 }}>
                  Control how participant demographics appear in AI responses
                </div>
                <ProjectSettingsCard className="demographicCard" style={{ border: 'none' }} bodyStyle={{ padding: 0 }}>
                  <Row gutter={[12, 12]} style={{ display: 'flex' }}>
                    <Col xs={24} sm={12} style={{ display: 'flex' }}>
                      <div
                        className={`providerOption ${createProjectDemographicFormat === 'anonymized' ? 'active' : ''}`}
                        onClick={() => setCreateProjectDemographicFormat('anonymized')}
                        style={{ padding: '6px 10px', gap: 8, width: '100%' }}
                      >
                        <ThemeRadio checked={createProjectDemographicFormat === 'anonymized'} />
                        <div className="providerIcon" style={{ width: 18, height: 18, minWidth: 18 }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" stroke="#6366f1" strokeWidth="2"/>
                            <path d="M12 6v6l4 2" stroke="#6366f1" strokeWidth="2" strokeLinecap="round"/>
                          </svg>
                        </div>
                        <div>
                          <div className="providerName" style={{ fontSize: 12 }}>General</div>
                          <div className="providerDesc" style={{ fontSize: 10 }}>Age ranges (18-24) & regions (Northeast)</div>
                        </div>
                      </div>
                    </Col>
                    <Col xs={24} sm={12} style={{ display: 'flex' }}>
                      <div
                        className={`providerOption ${createProjectDemographicFormat === 'detailed' ? 'active' : ''}`}
                        onClick={() => setCreateProjectDemographicFormat('detailed')}
                        style={{ padding: '6px 10px', gap: 8, width: '100%' }}
                      >
                        <ThemeRadio checked={createProjectDemographicFormat === 'detailed'} />
                        <div className="providerIcon" style={{ width: 18, height: 18, minWidth: 18 }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M2 17l10 5 10-5" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M2 12l10 5 10-5" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                        <div>
                          <div className="providerName" style={{ fontSize: 12 }}>Detailed</div>
                          <div className="providerDesc" style={{ fontSize: 10 }}>Exact ages (25) & locations (Oregon)</div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </ProjectSettingsCard>
              </div>
            )}
          </>
        )}
      </ThemeModal>

      {/* Export as Template Modal */}
      <ThemeModal
        title="Export as Template"
        open={saveTemplateModalVisible}
        onCancel={() => {
          setSaveTemplateModalVisible(false);
          setTemplateName('');
        }}
        onOk={handleSaveAsTemplate}
        okText="Export"
        okButtonProps={{
          disabled: !templateName.trim(),
          loading: saveCampaignTemplateState.apiState === 'loading',
        }}
        width={480}
        destroyOnClose
      >
        <div style={{ marginBottom: 8 }}>
          <label>Template Name</label>
        </div>
        <ThemeInput
          size="large"
          placeholder="Enter template name"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
          maxLength={100}
          onPressEnter={() => {
            if (templateName.trim()) handleSaveAsTemplate();
          }}
        />
      </ThemeModal>

      {/* FEOT Not Enabled Confirmation Modal */}
      <ThemeModal
        title={
          <Space>
            <ExclamationCircleOutlined style={{ color: '#faad14' }} />
            FEOT Not Enabled
          </Space>
        }
        open={feotModal.visible}
        onOk={handleFeotTurnOff}
        onCancel={() => setFeotModal({ visible: false, operation: null })}
        okText={feotModal.operation === 'publish' ? 'Turn Off & Publish' : 'Turn Off & Sync'}
        cancelText="Cancel"
        confirmLoading={feotLoading}
      >
        <p>
          The "Field Evenly Over Time" option is not enabled for this buyer account in PureSpectrum. Would you like to turn it off and {feotModal.operation === 'publish' ? 'publish' : 'sync'}?
        </p>
      </ThemeModal>
    </>
  );
};

const mapStateToProps = (state) => ({
  getCampaignByIdState: state.campaign.getCampaignByIdState,
  publishToPureSpectrumState: state.campaign.publishToPureSpectrumState,
  launchCampaignState: state.campaign.launchCampaignState,
  pauseCampaignState: state.campaign.pauseCampaignState,
  resumeCampaignState: state.campaign.resumeCampaignState,
  closeCampaignState: state.campaign.closeCampaignState,
  forceCloseCampaignState: state.campaign.forceCloseCampaignState,
  syncCampaignState: state.campaign.syncCampaignState,
  getTranscriptStatsState: state.campaign.getTranscriptStatsState,
  createProjectFromCampaignState: state.project.createProjectFromCampaignState,
  updateCPIState: state.campaign.updateCPIState,
  getElevenLabsCreditsState: state.campaign.getElevenLabsCreditsState,
  saveCampaignTemplateState: state.campaignTemplate.saveCampaignTemplateState,
  getPureSpectrumStatsState: state.campaign.getPureSpectrumStatsState,
});

const mapDispatchToProps = (dispatch) => ({
  getCampaignById: (id) => dispatch(getCampaignByIdApi(id)),
  getCampaignByIdReset: () => dispatch(getCampaignByIdReset()),
  publishToPureSpectrum: (id) => dispatch(publishToPureSpectrumApi(id)),
  publishToPureSpectrumReset: () => dispatch(publishToPureSpectrumReset()),
  launchCampaign: (id) => dispatch(launchCampaignApi(id)),
  launchCampaignReset: () => dispatch(launchCampaignReset()),
  pauseCampaign: (id) => dispatch(pauseCampaignApi(id)),
  pauseCampaignReset: () => dispatch(pauseCampaignReset()),
  resumeCampaign: (id) => dispatch(resumeCampaignApi(id)),
  resumeCampaignReset: () => dispatch(resumeCampaignReset()),
  closeCampaign: (id) => dispatch(closeCampaignApi(id)),
  closeCampaignReset: () => dispatch(closeCampaignReset()),
  forceCloseCampaign: (id) => dispatch(forceCloseCampaignApi(id)),
  forceCloseCampaignReset: () => dispatch(forceCloseCampaignReset()),
  syncCampaign: (id) => dispatch(syncCampaignApi(id)),
  syncCampaignReset: () => dispatch(syncCampaignReset()),
  getTranscriptStats: (id) => dispatch(getTranscriptStatsApi(id)),
  getTranscriptStatsReset: () => dispatch(getTranscriptStatsReset()),
  createProjectFromCampaign: (data) => dispatch(createProjectFromCampaignApi(data)),
  createProjectFromCampaignReset: () => dispatch(createProjectFromCampaignReset()),
  updateCPI: (id, cpi) => dispatch(updateCPIApi(id, cpi)),
  updateCPIReset: () => dispatch(updateCPIReset()),
  getElevenLabsCredits: () => dispatch(getElevenLabsCreditsApi()),
  getElevenLabsCreditsReset: () => dispatch(getElevenLabsCreditsReset()),
  saveCampaignTemplate: (data) => dispatch(saveCampaignTemplateApi(data)),
  saveCampaignTemplateReset: () => dispatch(saveCampaignTemplateReset()),
  getPureSpectrumStats: (id) => dispatch(getPureSpectrumStatsApi(id)),
  getPureSpectrumStatsReset: () => dispatch(getPureSpectrumStatsReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignDetail);
